// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          boxShadow: 'none',
          minHeight: 36,
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedPrimary: {
          border: `1px solid ${theme.palette.primary.dark}`,
        },
        outlined: {
          borderColor: theme.palette.divider,
        },
        containedInherit: {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.grey[800],
          '&:hover': {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.grey[800],
          },
        },
        sizeLarge: {
          minHeight: 48,
        },
      },
    },
  };
}
